import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { checkPaymentStatus } from "../../../redux/api/website/CheckoutApi";
import Shoploader from "../loader/Shoploader";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [status, setStatus] = useState('verifying');
  const [retryCount, setRetryCount] = useState(0);

  useEffect(() => {
    const verifyPayment = async () => {
      const params = new URLSearchParams(location.search);
      const razorpayPaymentId = params.get('razorpay_payment_id');
      const razorpayOrderId = params.get('razorpay_order_id');
      
      const orderId = sessionStorage.getItem('currentOrderId');

      if (!orderId) {
        toast.error("No order information found");
        navigate('/checkout');
        return;
      }

      try {
        // Try to get payment status
        const statusRes = await checkPaymentStatus(orderId);
        
        if (statusRes.success && statusRes.status === "Paid") {
          // Payment confirmed
          setStatus('success');
          localStorage.setItem('paymentSuccess', 'true');
          localStorage.setItem('paymentOrderId', orderId);
          
          // Redirect after 3 seconds
          setTimeout(() => {
            navigateToOrderConfirm(navigate, orderId);
          }, 3000);
        } else if (retryCount < 10) {
          // Retry a few times (webhook might be delayed)
          setTimeout(() => {
            setRetryCount(prev => prev + 1);
          }, 3000);
        } else {
          // Still show success - webhook will update later
          setStatus('pending');
          localStorage.setItem('paymentSuccess', 'true');
          localStorage.setItem('paymentOrderId', orderId);
          
          setTimeout(() => {
            navigateToOrderConfirm(navigate, orderId);
          }, 3000);
        }
      } catch (error) {
        console.error("Verification error:", error);
        console.error("Verification error:sss", error);
        if (retryCount < 10) {
          setTimeout(() => {
            setRetryCount(prev => prev + 1);
          }, 3000);
        } else {
          setStatus('pending');
          setTimeout(() => {
            navigateToOrderConfirm(navigate, orderId);
          }, 3000);
        }
      }
    };

    verifyPayment();
  }, [retryCount, location, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-[#fbfbfb] to-[#f7f7f7]">
      <div className="max-w-md w-full mx-auto p-8">
        {status === 'verifying' && (
          <div className="text-center">
            <Shoploader />
            <p className="mt-4 text-gray-600">Verifying your payment...</p>
            <p className="text-sm text-gray-500 mt-2">This may take a few moments</p>
          </div>
        )}
        
        {status === 'success' && (
          <div className="bg-white rounded-lg shadow-lg p-8 text-center">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-10 h-10 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Payment Successful!</h2>
            <p className="text-gray-600 mb-4">Your order has been confirmed.</p>
            <p className="text-sm text-gray-500">Redirecting to order summary...</p>
          </div>
        )}
        
        {status === 'pending' && (
          <div className="bg-white rounded-lg shadow-lg p-8 text-center">
            <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-10 h-10 text-yellow-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Payment Received!</h2>
            <p className="text-gray-600 mb-4">We're confirming your payment. You'll receive an email shortly.</p>
            <p className="text-sm text-gray-500">Redirecting to order summary...</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccess;

export const navigateToOrderConfirm = (navigate, orderId) => {
  const amount = sessionStorage.getItem("orderAmount");
  const address = JSON.parse(
    sessionStorage.getItem("selectedAddress")
  );

  navigate("/orderconfirm", {
    state: {
      orderId,
      amount,
      selectedAddress: address,
    },
  });

  sessionStorage.removeItem("currentOrderId");
  sessionStorage.removeItem("orderAmount");
  sessionStorage.removeItem("selectedAddress");
};